var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4425 35.21L21.25 33.08V28.75C21.25 28.06 20.69 27.5 20 27.5C19.31 27.5 18.75 28.06 18.75 28.75V33.08L15.5575 35.21C14.9825 35.5925 14.8275 36.37 15.21 36.9425C15.59 37.515 16.3625 37.67 16.9425 37.29L20 35.2525L23.0575 37.29C23.27 37.4325 23.51 37.5 23.75 37.5C24.1525 37.5 24.5475 37.305 24.79 36.9425C25.1725 36.37 25.0175 35.5925 24.4425 35.21Z",
    fill: "#455A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 5H3.75C3.06 5 2.5 5.5575 2.5 6.25V27.5C2.5 28.88 3.6225 30 5 30H35C36.38 30 37.5 28.88 37.5 27.5V6.25C37.5 5.5575 36.94 5 36.25 5Z",
    fill: "#ECEFF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 2.5H1.25C0.56 2.5 0 3.0575 0 3.75V6.25C0 6.94 0.56 7.5 1.25 7.5H38.75C39.44 7.5 40 6.94 40 6.25V3.75C40 3.0575 39.44 2.5 38.75 2.5Z",
    fill: "#455A64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 25C29.7018 25 32.5 22.2018 32.5 18.75C32.5 15.2982 29.7018 12.5 26.25 12.5C22.7982 12.5 20 15.2982 20 18.75C20 22.2018 22.7982 25 26.25 25Z",
    fill: "#4CAF50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5H7.5V25H10V17.5Z",
    fill: "#2196F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5H12.5V25H15V12.5Z",
    fill: "#2196F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 12.5V18.75H32.5C32.5 15.305 29.6975 12.5 26.25 12.5Z",
    fill: "#FFC107"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.502feca8311771d9355aa786064f16ae.svg";
export { ForwardRef as ReactComponent };